import { render, staticRenderFns } from "./rosters-upload-list.vue?vue&type=template&id=18ebadc4&scoped=true&"
import script from "./rosters-upload-list.ts?vue&type=script&lang=ts&"
export * from "./rosters-upload-list.ts?vue&type=script&lang=ts&"
import style0 from "./rosters-upload-list.scss?vue&type=style&index=0&id=18ebadc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebadc4",
  null
  
)

export default component.exports